"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MMA = void 0;
const sam_1 = require("./sam");
const utils_1 = require("./utils");
const message_manager_1 = require("./message-manager");
const utils_2 = require("./utils");
const uuid_1 = require("uuid");
// if multiple messages need to be sent at the same time we use this priority
let messagePriority = ["objectiveDeactivationMessage", "activityDeactivationMessage", "objectiveActivationMessage", "activityActivationMessage", "blockedMessage", "stableMessage", "regressionMessage", "overcomedBlockingMessage", "improvementMessage"];
class MMA extends sam_1.Agent {
    constructor(messageList) {
        super();
        this.numberOfActivityOpened = 0;
        this.multipleEvent = false;
        this.multipleEventList = [];
        this.bufferedMessage = {};
        this.eventList = new utils_1.DefaultDict(Array);
        this.last_exId = "";
        this.messageSelector = new message_manager_1.MessageSelector(messageList);
    }
    /**
     * update current event and add to the list of events
     * @param event new event emited through the stream
     */
    new_event(event) {
        this.currentEvent = event;
        if (event.type == "AIScoreVariationEvent") {
            let actID = event.data.activityId;
            this.eventList[actID].push(event.data.variationType);
        }
    }
    /**
     * check the event type of the new event to do the corresponding treatment
     * if needed calls generate_and_emit_event
     * @param eventStream
    */
    check_event(eventStream) {
        if (this.currentEvent.type == "ResultExerciseEvent") {
            this.lastSavedAnswer = this.currentEvent.data.correct;
            this.check_if_message_in_buffer_and_if_need_to_be_sent(this.currentEvent, eventStream);
        }
        else if (this.currentEvent.type == 'AIScoreVariationEvent') {
            switch (this.currentEvent.data.variationType) {
                case "improvement":
                    if (this.currentEvent.data.graphLevel == "activity")
                        this.check_if_improvementEvent_needs_message(this.currentEvent, eventStream);
                    break;
                case "regression":
                    if (this.currentEvent.data.graphLevel == 'activity')
                        this.generate_and_emit_event(this.currentEvent, eventStream, utils_2.eventToMessageType[this.currentEvent.data.variationType], Number(this.lastSavedAnswer));
                    break;
                case 'blocked':
                case 'stable':
                    if (this.currentEvent.data.graphLevel == "activity")
                        this.generate_and_emit_event(this.currentEvent, eventStream, utils_2.eventToMessageType[this.currentEvent.data.variationType]);
                    break;
            }
        }
        else
            this.check_if_zpdes_events_needs_message(this.currentEvent, eventStream);
    }
    /**
     * check if zpdes related event (activation/deactivation) needs a message
     * @param event
     * @param eventStream
     */
    check_if_zpdes_events_needs_message(event, eventStream) {
        if (event.type == "AIDeactivationEvent") {
            let event_to_treat = event;
            // in case multiple activities are deactivated at the same time we look at the exercise Id to see if they are related
            if (event_to_treat.data.exerciseId != this.last_exId) {
                let index = Number(!this.lastSavedAnswer); // if it is true we send the index 0 and if not 1 
                this.generate_and_emit_event(event_to_treat, eventStream, utils_2.eventToMessageType[event_to_treat.data.graphLevel + "Deactivation"], index);
            }
            this.last_exId = event_to_treat.data.exerciseId;
        }
        else {
            let event_to_treat = event;
            if (event_to_treat.data.graphLevel == "objective") {
                //this.permanentState = true;
                this.generate_and_emit_event(event_to_treat, eventStream, utils_2.eventToMessageType[event_to_treat.data.graphLevel + "Activation"]);
            }
            else if (this.numberOfActivityOpened < 2) {
                this.numberOfActivityOpened += 1;
                this.generate_and_emit_event(event_to_treat, eventStream, utils_2.eventToMessageType[event_to_treat.data.graphLevel + "Activation"]);
            }
        }
    }
    /**
     * check which type of improvement it is based on the criteria that detected the variation to distinguish between instantaneous improvement and long improvement
     * decide which message to generate based on the type of improvement and permanenState
     * @param eventStream
    */
    check_if_improvementEvent_needs_message(event, eventStream) {
        // if (this.currentEvent.data.variationData.criteria.crit_param.stepToCompute == 1) {
        //     if (!this.permanentState) {
        //         this.generate_and_emit_event(eventStream, 'improvementInstMessage');
        //     }
        // }
        // else {
        if (this.eventList[event.data.activityId].at(-1) == "blockedEvent") {
            this.generate_and_emit_event(event, eventStream, 'overcameBlockingMessage');
        }
        else if (Number(event.data.variationData.score) == 1) {
            this.generate_and_emit_event(event, eventStream, 'improvementMessage');
        }
        else {
            this.bufferedMessage[event.data.activityId] = 'improvementMessage';
            this.last_exId = event.data.exerciseId;
        }
        // }
    }
    check_if_message_in_buffer_and_if_need_to_be_sent(event, eventStream) {
        var _a, _b, _c;
        let actId = (_c = (_b = (_a = event.categoryData.parentItems) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "undefinedAct";
        let exerciseId = event.categoryData.learningItem.id;
        if (actId in this.bufferedMessage && exerciseId != this.last_exId) {
            if (event.data.correct)
                this.generate_and_emit_event(event, eventStream, this.bufferedMessage[actId]);
            delete this.bufferedMessage[actId];
        }
    }
    /**
     * create a new event object corresponding to a message type.
     * If multiple events comes at the same time appends a list of events
     * @param eventStream
     * @param message_type
    */
    generate_and_emit_event(event_1, eventStream_1, message_type_1) {
        return __awaiter(this, arguments, void 0, function* (event, eventStream, message_type, index = 0) {
            let event_data = this.generate_data(event, message_type, index);
            let event_to_send = {
                id: (0, uuid_1.v4)(),
                createdAt: new Date().toISOString(),
                type: "AIShowMessageEvent",
                userId: this.currentEvent.userId,
                sessionId: this.currentEvent.sessionId,
                app: this.currentEvent.app,
                data: event_data,
                categoryData: {
                    author: "MMA",
                    workmode: event.categoryData.workmode
                }
            };
            if (!this.multipleEvent) {
                this.multipleEvent = true;
                this.multipleEventList.push(event_to_send);
                // might be too much delay
                yield this.sleep(100);
                if (this.multipleEventList.length > 1) {
                    this.handle_multiple_event(eventStream);
                }
                else
                    this.emit_event(event_to_send, eventStream);
                this.resetMultiEvent();
            }
            else if (this.multipleEvent) {
                this.multipleEventList.push(event_to_send);
            }
        });
    }
    /**
     * generate the eventData for the AthenaEvent
     * @param message_type
    */
    generate_data(event, message_type, index = 0) {
        // TEMPORARY FIX
        let even_to_use = event;
        // TO REMOVE
        let event_data = {
            graphLevel: even_to_use.data.graphLevel ? even_to_use.data.graphLevel : 'activity',
            moduleId: even_to_use.data.moduleId,
            objectiveId: even_to_use.data.objectiveId,
            activityId: even_to_use.data.activityId,
            exerciseId: even_to_use.data.exerciseId,
            messageType: message_type,
            index: index,
            //event_data['isPermanentState'] = this.permanentState;
        };
        return event_data;
    }
    /**
     * when multiple events arrive at the same time, prioritize the events and emit the one with the highest priority
     * after emiting reset the event list
     * @param eventStream
    */
    handle_multiple_event(eventStream) {
        let eventTypeList = [];
        this.multipleEventList.forEach((event) => { eventTypeList.push(event.data.messageType); });
        for (let messageType of messagePriority) {
            if (eventTypeList.includes(messageType)) {
                this.emit_event(this.multipleEventList[eventTypeList.lastIndexOf(messageType)], eventStream);
                break;
            }
        }
        this.resetMultiEvent();
    }
    /**
     * publish an event to the eventStream
     * @param event
     * @param eventStream
     */
    emit_event(event, eventStream) {
        eventStream.publish(event);
    }
    /**
     * reset the multiple event list
     */
    resetMultiEvent() {
        this.multipleEvent = false;
        this.multipleEventList = [];
    }
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    updateFromEvent(event, eventStream) {
        this.new_event(event);
        this.check_event(eventStream);
    }
}
exports.MMA = MMA;
